import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import ModalDialog from '../../common/ModalDialog';

const AddDoctorWithoutMobileModal: React.FC<{
    onCancel: () => void;
    onConfirm: () => void;
}> = ({ onCancel, onConfirm }) => {
    return (
        <Hotkeys keyName="esc">
            <ModalDialog>
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    style={{ zIndex: 20 }}
                    transition={{ duration: 0.2, ease: 'linear' }}
                    className="font-lato select-none"
                >
                    <div onClick={onCancel} className="modal-overlay"></div>
                    <div className="modal-content flex flex-col w-450 font-lato font-400 rounded-8">
                        <div className="bg-white flex flex-col rounded-12 items-center space-y-12">
                            <div className="w-full flex justify-end pr-8 pt-8">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    className="cursor-pointer"
                                    onClick={onCancel}
                                >
                                    <path
                                        d="M15.8848 8.60352L12.8379 11.6504L15.8594 14.6719C16.1133 14.9004 16.1133 15.2812 15.8594 15.5098C15.6309 15.7637 15.25 15.7637 15.0215 15.5098L11.9746 12.4883L8.95312 15.5098C8.72461 15.7637 8.34375 15.7637 8.11523 15.5098C7.86133 15.2812 7.86133 14.9004 8.11523 14.6465L11.1367 11.625L8.11523 8.60352C7.86133 8.375 7.86133 7.99414 8.11523 7.74023C8.34375 7.51172 8.72461 7.51172 8.97852 7.74023L12 10.7871L15.0215 7.76562C15.25 7.51172 15.6309 7.51172 15.8848 7.76562C16.1133 7.99414 16.1133 8.375 15.8848 8.60352Z"
                                        fill="#1A1A1A"
                                    />
                                </svg>
                            </div>
                            <div className="flex flex-col items-center px-24 pb-24">
                                <div className="flex flex-col items-center space-y-8">
                                    <span className="mt-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="27"
                                            height="24"
                                            viewBox="0 0 27 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M13.5 24C9.1875 24 5.25 21.75 3.09375 18C0.9375 14.2969 0.9375 9.75 3.09375 6C5.25 2.29688 9.1875 0 13.5 0C17.7656 0 21.7031 2.29688 23.8594 6C26.0156 9.75 26.0156 14.2969 23.8594 18C21.7031 21.75 17.7656 24 13.5 24ZM13.5 6C12.8438 6 12.375 6.51562 12.375 7.125V12.375C12.375 13.0312 12.8438 13.5 13.5 13.5C14.1094 13.5 14.625 13.0312 14.625 12.375V7.125C14.625 6.51562 14.1094 6 13.5 6ZM12 16.5C12 17.3438 12.6562 18 13.5 18C14.2969 18 15 17.3438 15 16.5C15 15.7031 14.2969 15 13.5 15C12.6562 15 12 15.7031 12 16.5Z"
                                                fill="#EDAE0C"
                                            />
                                        </svg>
                                    </span>
                                    <span className="text-20 text-center">
                                        Add doctor without mobile number?
                                    </span>
                                </div>
                                <span className="text-14 mt-16 text-darwin-neutral-800 text-center">
                                    Any notes or patient details will NOT be shared with the doctor
                                </span>

                                <div className="flex items-center space-x-16 pt-24">
                                    <button
                                        onClick={onCancel}
                                        className="primary-btn px-24 py-6 btn--small"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={onConfirm}
                                        className="px-24 py-5 btn--small secondary-btn space-x-8"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </ModalDialog>
        </Hotkeys>
    );
};

export default AddDoctorWithoutMobileModal;
